import { useState } from 'react';

import ClosePopUpButton from "../../ClosePopUpButton/ClosePopUpButton";
import { useContextValue } from "../../../context/context";
import Search from "../../Search/Search";
import { LanguageIcon } from "../../../assets/cardIcons";
import "./style.css";

//? Temporary data
const languagesData = ["Deutsch", "English", "Français", "Italiano", "Español", "Polski", "Português", "Nederlands", "Русский", "Українська", "Türkçe", "العربية", "עברית", "日本語", "中文", "한국어", "Baskisch", "Belarussisch", "Bengali", "Bosnisch", "Bulgarisch", "Dänisch", "Estnisch", "Finnisch", "Galicisch", "Georgisch", "Griechisch", "Haitianisch", "Hawaiisch", "Hebräisch", "Hindi", "Hmong", "Igbo", "Indonesisch", "Irisch", "Isländisch", "Javanisch", "Kannada", "Katalanisch", "Khmer", "Kinyarwanda", "Kirgisisch", "Koreanisch", "Korsisch", "Kroatisch", "Kurdisch", "Laotisch", "Lateinisch", "Lettisch", "Litauisch", "Luxemburgisch", "Malagasy", "Malayalam", "Malaysisch", "Maltesisch", "Maori", "Marathi", "Mazedonisch", "Mongolisch", "Nepali", "Norwegisch", "Paschtu", "Persisch", "Punjabi", "Rumänisch", "Samoanisch", "Schottisch", "Schwedisch", "Serbisch", "Sesotho", "Shona", "Sindhi", "Singhalesisch", "Slowakisch", "Slowenisch", "Somali", "Suaheli", "Sundanesisch", "Tadschikisch", "Tamil", "Telugu", "Thailändisch", "Tschechisch", "Türkmenisch", "Ungarisch", "Urdu", "Usbekisch", "Vietnamesisch", "Walisisch", "Xhosa", "Yoruba", "Zulu"];

const LanguagePopUp = ({ onClose }) => {
	const [searchLanguage, setSearchLanguage] = useState("");
	const { setSelectedLanguage, filledCards, setFilledCards } = useContextValue();

	const handleLanguage = (language) => {
		setSelectedLanguage(language);

		const newCard = { content: language, isSelected: true, title: "Sprache", backgroundColor: "#27999A", icon: LanguageIcon };
		const existingCardIndex = filledCards.findIndex(card => card.title === newCard.title);

		if (existingCardIndex !== -1) {
			// Якщо картка існує, створюємо новий масив з оновленою карткою
			const updatedCards = [...filledCards];
			updatedCards[existingCardIndex] = newCard;
			setFilledCards(updatedCards);
		} else {
			// Якщо картки немає, додаємо нову
			setFilledCards([...filledCards, newCard]);
		}

		onClose();
	}

	const handleSearch = (text) => {
		setSearchLanguage(text);
	}

	const filteredItems = languagesData.filter((language) =>
		language.toLowerCase().includes(searchLanguage.toLowerCase())
	);

	return (
		<div className="language-popup">
			<Search text="Suchsprache" setFunction={handleSearch} />
			<ul className="language-options">
				{filteredItems.length > 0 ? (
					filteredItems.map((language, index) => <li key={index} onClick={() => handleLanguage(language)} className="language-option">{language}</li>)
				) : (
					<li>Нічого не знайдено</li>
				)}
			</ul>
			<ClosePopUpButton onClose={onClose} />
		</div>
	)
}

export default LanguagePopUp